module.exports = __webpack_public_path__ + "static-portal/img/001.968d9c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/001.jpg
// module id = fcjh
// module chunks = 4